export default __webpack_public_path__ + "static/media/oa_1.447e9109.mp3";